import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84077688"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-military-green-500 pretitle" }, "Welcome to Skyline"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-rust-500" }, "Log in")
], -1))
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4 text-sm text-error-300",
  "data-testid": "error-message"
}
const _hoisted_5 = { class: "submit-area" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Log in ")
const _hoisted_7 = { class: "flex flex-col items-center mt-4" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-prompt" }, "Don't have an account? ", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Sign up ")
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-prompt" }, "Forgot your password? ", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Reset ")

import { ref } from 'vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInputComponent from '@/components/TextInputComponent.vue';
import Icon from '@/components/icon/Icon';
import Routes from '../../router/Routes';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  props: {
  error: {
    type: String
  },
  isLoading: {
    type: Boolean,
    default: false
  }
},
  emits: ['login'],
  setup(__props, { emit }) {



const email = ref('');
const password = ref('');
const emailLabel = 'Email';



function signIn() {
  emit('login', {
    email: email.value,
    password: password.value
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    class: "login-form-body"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextInputComponent, {
        helperText: emailLabel,
        placeholder: "Email",
        "data-test-id": "email-input",
        textIcon: _unref(Icon).MAIL,
        value: email.value,
        class: "w-full ml-2",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (email.value = $event))
      }, null, 8, ["textIcon", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TextInputComponent, {
        helperText: "Password",
        placeholder: "Password",
        "data-test-id": "password-input",
        textIcon: _unref(Icon).LOCK,
        value: password.value,
        type: "current-password",
        class: "w-full ml-2",
        hideValue: true,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (password.value = $event))
      }, null, 8, ["textIcon", "value"])
    ]),
    (__props.error && __props.error !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(ButtonComponent, {
          disabled: __props.isLoading,
          onClick: signIn,
          "data-cy": "sign-in-button",
          "color-type": "secondary",
          size: "large",
          "right-icon-value": _unref(Icon).ICON_FIELD_RIGHT
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "right-icon-value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_router_link, {
            to: _unref(Routes).SIGNUP,
            "data-testid": "sign-up-button",
            class: "underline sign-up-link"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_router_link, {
            class: "underline text-rust-500",
            to: _unref(Routes).PASSWORD_RESET
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ], 32))
}
}

})